import { createSlice } from "@reduxjs/toolkit";

import { get, patch, post } from "../../helpers/axios";
import {
  GET_PREASSESSMENT_CSV,
  PRE_ASSESSMENT_QUESTIONS,
  PRE_ASSESSMENT_SECTIONS,
  SUBMIT_PRE_ASSESSMENT,
} from "../../helpers/url_helpers";
import { downloadBlob } from "../../helpers/utils";

const initialState = {
  sections: [],
  questionData: {},
  preassementError: "",
  questionStatus: {},
  isPreassementLoading: false,
  isCsvDownloading: false,
};

const preAssessment = createSlice({
  name: "preAssessment",
  initialState,
  reducers: {
    setSections: (state, action) => {
      state.sections = action.payload.sections;
    },
    setPreassessmentLoading: (state, action) => {
      state.isPreassementLoading = action.payload;
    },
    setQuestionData: (state, action) => {
      state.questionData = action.payload.questionData;
    },
    setCSVLoading: (state, action) => {
      state.isCsvDownloading = action.payload.isCsvDownloading;
    },
    setError: (state, action) => {
      state.preassementError = action.payload.preassementError;
    },
  },
});

export const {
  setQuestionData,
  setSections,
  setPreassessmentLoading,
  setError,
  setCSVLoading,
} = preAssessment.actions;
export default preAssessment.reducer;

export const fetchPreassessmentSections = (history) => async (dispatch) => {
  let response;

  try {
    dispatch(setSections({ sections: {} }));
    dispatch(setError({ preassementError: "" }));

    // api call
    response = await get(PRE_ASSESSMENT_SECTIONS);

    if (response) {
      dispatch(setPreassessmentLoading(false));

      if (response.error) {
        dispatch(
          setError({
            preassementError: response?.error,
          })
        );
      } else {
        dispatch(
          setSections({
            sections: response?.data,
          })
        );
      }
    }
  } catch (error) {
    dispatch(setPreassessmentLoading(false));
    if (error)
      dispatch(
        setError({
          preassementError: error,
        })
      );
  }
};

export const fetchPreassessmentQuestions =
  (sectionId = "") =>
  async (dispatch) => {
    let response;

    try {
      dispatch(setPreassessmentLoading(true));
      dispatch(setQuestionData({ questionData: {} }));
      dispatch(setError({ preassementError: "" }));

      // api call
      response = await get(PRE_ASSESSMENT_QUESTIONS + sectionId + "/");

      if (response) {
        dispatch(setPreassessmentLoading(false));

        if (response.error) {
          dispatch(
            setError({
              preassementError: response?.error,
            })
          );
        } else {
          dispatch(
            setQuestionData({
              questionData: response?.data,
            })
          );
        }
      }
    } catch (error) {
      dispatch(setPreassessmentLoading(false));
      if (error)
        dispatch(
          setError({
            preassementError: error,
          })
        );
    }
  };

export const submitPreassessments =
  (data, isEdit, callback) => async (dispatch) => {
    let response;
    try {
      dispatch(setError({ preassementError: "" }));

      //api call
      if (isEdit) {
        response = await patch(SUBMIT_PRE_ASSESSMENT, data);
      } else response = await post(SUBMIT_PRE_ASSESSMENT, data);

      if (response) {
        dispatch(setPreassessmentLoading(false));

        if (response.error) {
          dispatch(
            setError({
              preassementError: response?.error,
            })
          );
        } else {
          callback && callback();
        }
      }
    } catch (error) {
      dispatch(setPreassessmentLoading(false));
      if (error)
        dispatch(
          setError({
            preassementError: error,
          })
        );
    }
  };

export const downloadPreAssessmentCSV = (callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setError({ preassementError: "" }));
    dispatch(setCSVLoading({ isCsvDownloading: true }));
    // api call
    response = await get(GET_PREASSESSMENT_CSV);

    if (response) {
      if (response.error) {
        dispatch(
          setError({
            preassementError: response?.error,
          })
        );
      } else {
        downloadBlob(response, `Pre-assessment.csv`);

        if (callback) callback();
      }
      dispatch(setCSVLoading({ isCsvDownloading: false }));
    }
  } catch (error) {
    if (error)
      dispatch(
        setError({
          preassementError: error,
        })
      );
    dispatch(setCSVLoading({ isCsvDownloading: false }));
  }
};
